import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom-v5-compat';

import TransactionHistoryGrid from './grid';
import messages from './messages';
import style from './style.module.less';
import SubscriptionTab from './subscription-tab/subscription-tab';
import { useAreFeatureFlagsReady } from '../../../feature-flags/hooks/use-are-feature-flags-ready';
import { useEnableBalanceHistory } from '../../../feature-flags/hooks/use-enable-balance-history';
import { useDefaultLoginRoute } from '../../../hooks/use-user-setting';
import {
  BALANCE_HISTORY_PATH,
  SUBSCRIPTION_PATH,
  getBalanceHistoryPathForWalletId,
  getSubscriptionInvoiceHistoryPath,
} from '../../../routes/constants';
import Global from '../../../store/global-selectors';
import { SettingsPageTitle } from '../components/settings-page-title/settings-page-title';
import InvoiceGridLoading from '../payment-and-subscription/components/invoice-grid-loading/index';
import InvoicesContextProvider from '../payment-and-subscription/invoices-context';

const walletPathParam = ':walletId';

const NavigateBasedOnWallets = ({ wallets }) => {
  return wallets[0] ? (
    <Navigate to={getBalanceHistoryPathForWalletId(wallets[0]?.walletId)} />
  ) : (
    <Navigate to={getSubscriptionInvoiceHistoryPath()} />
  );
};

const TransactionHistory = () => {
  const wallets = useSelector(Global.selectSellerWallets);

  return (
    <div className={style['sub-page']}>
      <div className={style['transaction-history-page-header']}>
        <SettingsPageTitle value={messages.transactionHistory} />
      </div>
      <div className={style.tabs}>
        {wallets.map((wallet) => (
          <NavLink
            key={wallet.walletId}
            className={({ isActive }) =>
              classNames(style['tab-link'], {
                [style['active-tab-link']]: isActive,
              })
            }
            to={getBalanceHistoryPathForWalletId(wallet.walletId)}
          >
            {wallets.length > 1 ? (
              <FormattedMessage {...messages.namedWalletBalance} values={{ nickname: wallet.nickname }} />
            ) : (
              <FormattedMessage {...messages.balance} />
            )}
          </NavLink>
        ))}
        <NavLink
          className={({ isActive }) =>
            classNames(style['tab-link'], {
              [style['active-tab-link']]: isActive,
            })
          }
          to={getSubscriptionInvoiceHistoryPath()}
        >
          <FormattedMessage {...messages.subscription} />
        </NavLink>
      </div>
      <Routes>
        <Route
          element={
            <InvoicesContextProvider>
              <SubscriptionTab />
            </InvoicesContextProvider>
          }
          path={SUBSCRIPTION_PATH}
        />

        <Route element={<TransactionHistoryGrid wallets={wallets} />} path={`${walletPathParam}${BALANCE_HISTORY_PATH}/*`} />
        <Route element={<NavigateBasedOnWallets wallets={wallets} />} index />
      </Routes>
    </div>
  );
};

const FeatureFlaggedTransactionHistory = () => {
  const defaultRoute = useDefaultLoginRoute();
  const enableBalanceHistory = useEnableBalanceHistory();
  const featureFlagsReady = useAreFeatureFlagsReady();

  if (!featureFlagsReady) {
    return <InvoiceGridLoading shouldHideLeftNavWhenLoading={false} />;
  }

  return !enableBalanceHistory ? <Navigate to={defaultRoute} /> : <TransactionHistory />;
};

export default FeatureFlaggedTransactionHistory;
